$(".new-iwa-acc-title").click(function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().toggleClass("active");
    let src = $(this).parent().find(".new-iwa-acc-img").attr("src");
    $(this).parents(".new-iwa-wrapper").find(".new-iwa-img").attr("src", src);
  }
  else{
    $(this).parents(".new-iwa-content-wrapper").find(".new-iwa-acc-title").removeClass("active");
    $(this).parents(".new-iwa-content-wrapper").find(".new-iwa-acc-content").removeClass("active");
    $(this).addClass("active");
    $(this).next().addClass("active");
    let src = $(this).parent().find(".new-iwa-acc-img").attr("src");
    $(this).parents(".new-iwa-wrapper").find(".new-iwa-img").attr("src", src);
  }
})

$(".new-lg-menu-item").click(function(){
  $(this).toggleClass("active");
  $(this).next(".new-lg-menu-ul ").toggleClass("active");
})

document.addEventListener("DOMContentLoaded", () => {
  const menuLinks = document.querySelectorAll(".new-lg-menu-li a");
  const sections = [];

  menuLinks.forEach(link => {
    const href = link.getAttribute("href");
    // Only process valid internal links like "#something"
    if (href && href.startsWith("#") && href.length > 1) {
      const target = document.querySelector(href);
      if (target) {
        sections.push({ id: href, element: target, link: link });
      }
    }
  });

  if (sections.length === 0) return; // nothing to observe

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = "#" + entry.target.id;
        const activeSection = sections.find(s => s.id === id);
        if (activeSection) {
          document.querySelectorAll(".new-lg-menu-li.active").forEach(el => el.classList.remove("active"));
          activeSection.link.closest(".new-lg-menu-li").classList.add("active");
        }
      }
    });
  }, { threshold: 0.5 });

  sections.forEach(s => observer.observe(s.element));
});

$(".new-grid-tab").click(function(){
  let index = parseInt($(this).attr("data-index"));
  $(this).parent().find(".new-grid-tab").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".new-grid-wrapper").find(".new-grid-swiper")[0].swiper.slideTo(index);
})